import ApiClient from '../../../utils/ApiClient';

export const LOAD = 'common/metaData/LOAD';
export const LOAD_SUCCESS = 'common/metaData/SUCCESS';
export const LOAD_FAIL = 'common/metaData/FAILURE';

const apiClient = new ApiClient();

export default function fetchMetadata() {
    return {
        types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
        promise: () => apiClient.get('api/cms-app/pagemetadata')
    }
}


// WEBPACK FOOTER //
// ./modules/Common/actions/metaData.js